export default "__VITE_ASSET__AIifECVv__"